/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  TelegramAuthControllerExchangeLoginCodeMutationRequest,
  TelegramAuthControllerExchangeLoginCodeMutationResponse,
  TelegramAuthControllerExchangeLoginCode401,
  TelegramAuthControllerExchangeLoginCode403,
} from '../../types/TelegramAuthControllerExchangeLoginCode.ts';
import type { UseMutationOptions, QueryClient } from '@tanstack/react-query';
import { telegramAuthExchangeLoginCode } from '../../methods/telegramAuthExchangeLoginCode.ts';
import { useMutation } from '@tanstack/react-query';

export const telegramAuthExchangeLoginCodeMutationKey = () =>
  [{ url: '/api/telegram/auth/login-code/exchange' }] as const;

export type TelegramAuthExchangeLoginCodeMutationKey = ReturnType<typeof telegramAuthExchangeLoginCodeMutationKey>;

/**
 * {@link /api/telegram/auth/login-code/exchange}
 */
export function useTelegramAuthExchangeLoginCode<TContext>(
  options: {
    mutation?: UseMutationOptions<
      TelegramAuthControllerExchangeLoginCodeMutationResponse,
      ResponseErrorConfig<TelegramAuthControllerExchangeLoginCode401 | TelegramAuthControllerExchangeLoginCode403>,
      { data: TelegramAuthControllerExchangeLoginCodeMutationRequest },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig<TelegramAuthControllerExchangeLoginCodeMutationRequest>> & { client?: typeof fetch };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey = mutationOptions.mutationKey ?? telegramAuthExchangeLoginCodeMutationKey();

  return useMutation<
    TelegramAuthControllerExchangeLoginCodeMutationResponse,
    ResponseErrorConfig<TelegramAuthControllerExchangeLoginCode401 | TelegramAuthControllerExchangeLoginCode403>,
    { data: TelegramAuthControllerExchangeLoginCodeMutationRequest },
    TContext
  >(
    {
      mutationFn: async ({ data }) => {
        return telegramAuthExchangeLoginCode(data, config);
      },
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  );
}
